module.exports = __webpack_public_path__ + "static/media/AddCard.2b5f13e6.svg";